var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.openPurchasesTableSettings.apply(null, arguments)}}},[_c('ico',{attrs:{"name":"icoSettings"}}),_c('span',[_vm._v("Настройки таблицы")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }